import { useEffect } from 'react';
import i18next from 'i18next';
import MagexLogo from '../../Icons/Magex_logo.png';
import { useHistory } from 'react-router';
import localRequest from '../../services/LocalServer/localRequest';
import request from '../../services/Request';
import logger from '../../services/LocalServer/logger';
import { useTranslation } from 'react-i18next';

const getMachineURL = `${process.env.REACT_APP_LOCAL_API}/getMachine`;
const getPromoURL = `${process.env.REACT_APP_LOCAL_API}/getPromo`;
const getAllProdURL = `${process.env.REACT_APP_LOCAL_API}/getProduct`;
const getAllCateURL = `${process.env.REACT_APP_LOCAL_API}/getCategory`;
const getAllBrandURL = `${process.env.REACT_APP_LOCAL_API}/getBrand`;
const getReinstate = `${process.env.REACT_APP_LOCAL_API}/getReinstateStatus`;

const getMachineURLR = `${process.env.REACT_APP_SERVER_API}/machines/edit/`;
const getPromoURLR = `${process.env.REACT_APP_SERVER_API}/promos/machine/`;
const getAllProdURLR = `${process.env.REACT_APP_SERVER_API}/machines/getMachineUIproduct/`;
const getAllCateURLR = `${process.env.REACT_APP_SERVER_API}/machines/getFilteredCategroy/`;
const getAllBrandURLR = `${process.env.REACT_APP_SERVER_API}/machines/getFilteredBrand/`;

function Initial(props) {
  const { t } = useTranslation();
  const { stat, setStat } = props;
  const history = useHistory();
  const machineID = props.id;

  let outofStock = false;
  let items = [];
  let filteredProducts = [];
  let categoryArray = [];
  let language = 'en';
  let isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';

  useEffect(async () => {
    if (props.test !== 'true') {
      const instateStatus = new Promise((resolve, reject) => {
        localRequest({
          method: 'get',
          url: getReinstate,
        }).then((res) => {
          console.log('reinstate', res.data);
          if (res.data) resolve(1);
          else resolve(0);
        });
      });
      const isGo = await instateStatus;
      const delay = (ms) => new Promise((res) => setTimeout(res, ms));

      if (isGo) {
        await delay(localStorage.getItem('INI_TIME') ? localStorage.getItem('INI_TIME') : 10000);
      }
    }
    await props.setShowCart(false);
    props.cleanUp();
    let myMachineObj = null;
    localStorage.removeItem('MagexApp.cart');
    localStorage.removeItem('promo');
    localStorage.removeItem('codePromo');
    localStorage.removeItem('oneTime');
    localStorage.removeItem('machine');
    localStorage.removeItem('products');
    localStorage.removeItem('category');
    localStorage.removeItem('brand');
    let machine = null;

    const voidMachine = (res, setDefaultLogo) => {
      let promise = new Promise((resolve, reject) => {
        const style = document.createElement('style');
        document.head.appendChild(style);

        //set primary language
        i18next.changeLanguage(res.data.languages[0].code);
        props.setlangs(res.data.languages[0].code);
        language = res.data.languages[0].code;
        localStorage.setItem('machineID', machineID);
        localStorage.setItem('machine', JSON.stringify(res.data));
        myMachineObj = res.data;
        props.setMachine(res.data);
        machine = res.data;
        resolve('done');
      });
      promise.then();
    };

    const voidProd = async (res) => {
      const copy = [...res.data];
      let products = res.data;
      //filter hided products
      const hideProducts = myMachineObj.products_hide;
      hideProducts.forEach((hide) => {
        let hideIndex = products.findIndex((e) => hide == e._id);
        if (hideIndex > -1) {
          products.splice(hideIndex, 1);
        }
      });

      const bestMachineArray = myMachineObj.products_bs;
      const bestSeller = [];
      copy.forEach((item, i) => {
        item.idx = i;
        if (!item.name.es) {
          item.name.es = '';
        }
        if (!item.name.fr) {
          item.name.fr = '';
        }
      });
      if (props.test === 'true' || process.env.REACT_APP_DEV === 'TRUE') {
        console.log('goes in');
        bestMachineArray?.forEach((bsProd) => {
          let index = copy.findIndex((e) => e._id == bsProd);
          if (index > -1) {
            bestSeller.push(copy[index]);
          }
        });
        localStorage.setItem('bestSeller', JSON.stringify(bestSeller));
      } else {
        console.log('itemin', items);
        console.log('allprod', products);
        let i = 0;
        items.forEach((item) => {
          let index = products.findIndex((e) => e.upc == item.upc);
          if (index >= 0) {
            products[index].current_stock = item.current_stock;
            products[index].max_stock = item.max_stock;
            products[index].idx = i;
            if (!products[index].name.es) {
              products[index].name.es = '';
            }
            if (!products[index].name.fr) {
              products[index].name.fr = '';
            }
            i++;
            filteredProducts.push(products[index]);
          }
        });
        i = 0;
        // console.log('filteredProduct', filteredProducts);
        // console.log('bestMachineArray', bestMachineArray);
        bestMachineArray?.forEach((bsProd) => {
          let index = filteredProducts.findIndex((e) => e._id == bsProd);
          if (index > -1) {
            bestSeller.push(filteredProducts[index]);
          }
        });
        localStorage.setItem('bestSeller', JSON.stringify(bestSeller));
        // console.log('bbsl', bestSeller);
      }

      try {
        const codePromo = JSON.parse(localStorage.getItem('promo'));
        // console.log(codePromo);
        //  console.log(codePromo)
        if (codePromo.length > 0) {
          codePromo.forEach((item) => {
            if (item.promoType === 'buyXProducts') {
              if (item.cateOrProd === 'cate') {
                if (item.category) {
                  for (let i = 0; i < item.category.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      //add !products[j].prodPromo for improve prod promotion priority
                      if (
                        !products[j].prodPromo &&
                        products[j].category.includes(item.category[i]._id)
                      ) {
                        products[j].promo = item._id;
                        products[j].buyX = item.productsToBuy;
                        products[j].percentage = item.percentage;
                        products[j].discount = item.amount;
                        products[j].discountedPrice = item.percentage
                          ? products[j].price * (1 - item.amount)
                          : products[j].price - item.amount;
                        products[j].discountedPrice =
                          Math.round(products[j].discountedPrice * 100) / 100;
                        // products[j].discountedPrice = products[j].discountedPrice > 0 ? products[j].discountedPrice : 0.01;
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === 'prod') {
                if (item.product) {
                  for (let i = 0; i < item.product.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      if (item.product[i]._id == products[j]._id) {
                        products[j].discountedPrice = item.percentage
                          ? products[j].price * (1 - item.amount)
                          : products[j].price - item.amount;
                        products[j].discountedPrice =
                          Math.round(products[j].discountedPrice * 100) / 100;
                        products[j].buyX = item.productsToBuy;
                        products[j].promo = item._id;
                        products[j].discount = item.amount;
                        products[j].percentage = item.percentage;
                        // products[j].discountedPrice = products[j].discountedPrice > 0 ? products[j].discountedPrice : 0;
                        // for checking prod promotion priority more
                        products[j].prodPromo = true;
                        console.log('11');
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === 'All Products') {
                products.forEach((product) => {
                  products.promo = item._id;
                  product.percentage = item.percentage;
                  product.discountedPrice = item.percentage
                    ? product.price * (1 - item.amount)
                    : product.price - item.amount;
                  product.discountedPrice = Math.round(product.discountedPrice * 100) / 100;
                  product.discount = item.amount;
                  product.buyX = item.productsToBuy;
                  product.percentage = item.percentage;
                  // product.discountedPrice = product.discountedPrice > 0 ? product.discountedPrice : 0;
                });
              }
            } else if (item.promoType === 'general' || item.promoType === 'emailCode') {
              if (item.cateOrProd === 'cate') {
                if (item.category) {
                  for (let i = 0; i < item.category.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      //add !products[j].prodPromo for improve prod promotion priority
                      if (
                        !products[j].prodPromo &&
                        products[j].category.includes(item.category[i]._id)
                      ) {
                        if (item.promoType === 'emailCode') {
                          products[j].emailCode = true;
                        }
                        products[j].promo = item._id;
                        products[j].discountedPrice = item.percentage
                          ? products[j].price * (1 - item.amount)
                          : products[j].price - item.amount;
                        products[j].discountedPrice =
                          Math.round(products[j].discountedPrice * 100) / 100;
                        products[j].buyX = 0;
                        products[j].discount = item.amount;
                        products[j].percentage = item.percentage;
                        // products[j].discountedPrice = products[j].discountedPrice > 0 ? products[j].discountedPrice : 0.01;
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === 'prod') {
                if (item.product) {
                  for (let i = 0; i < item.product.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      if (item.product[i]._id == products[j]._id) {
                        if (item.promoType === 'emailCode') {
                          products[j].emailCode = true;
                        }
                        products[j].promo = item._id;
                        products[j].discountedPrice = item.percentage
                          ? products[j].price * (1 - item.amount)
                          : products[j].price - item.amount;
                        products[j].discountedPrice =
                          Math.round(products[j].discountedPrice * 100) / 100;
                        products[j].buyX = 0;
                        products[j].discount = item.amount;
                        products[j].percentage = item.percentage;
                        // products[j].discountedPrice = products[j].discountedPrice > 0 ? products[j].discountedPrice : 0;
                        // for checking prod promotion priority
                        products[j].prodPromo = true;
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === 'All Products') {
                products.forEach((product) => {
                  if (item.promoType === 'emailCode') {
                    product.emailCode = true;
                  }
                  product.promo = item._id;
                  product.discountedPrice = item.percentage
                    ? product.price * (1 - item.amount)
                    : product.price - item.amount;
                  product.discountedPrice = Math.round(product.discountedPrice * 100) / 100;
                  product.buyX = 0;
                  product.discount = item.amount;
                  product.percentage = item.percentage;
                  // product.discountedPrice = product.discountedPrice > 0 ? product.discountedPrice : 0;
                });
              }
            }
          });
        }
        // initial products state
        if (props.test === 'true' || process.env.REACT_APP_DEV === 'TRUE') {
          // console.log('copy', copy);
          props.setProds(copy);
        } else {
          props.setProds(filteredProducts);
        }
      } catch (e) {
        logger(0, 'Errors when apply promotion to products. ' + JSON.stringify(e));
      }
    };

    const getMachine = async () => {
      const setDefaultLogo = (style) => {
        document.querySelector('.homeImg').style.content = `url(${MagexLogo})`;
        style.sheet.insertRule(`
                .category-logo {
                    content: url(${MagexLogo})
                }
            `);
      };
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getMachineURL,
        })
          .then((res) => {
            console.log('localMachine', res.data);
            voidMachine(res, setDefaultLogo);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        await request({
          method: 'get',
          url: getMachineURLR + machineID,
        })
          .then((res) => {
            console.log('remoteMachine', res.data);
            voidMachine(res, setDefaultLogo);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    };

    const getPromo = async () => {
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getPromoURL,
        })
          .then((res) => {
            console.log('localPromo', res.data);
            localStorage.setItem('promo', JSON.stringify(res.data));
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        await request({
          method: 'get',
          url: getPromoURLR + machineID,
        })
          .then((res) => {
            localStorage.setItem('promo', JSON.stringify(res.data));
          })
          .catch((err) => {
            console.log(err);
          });
      }
    };

    const updateStatus = async () => {
      if (props.test == 'false') {
        await localRequest({
          method: 'get',
          url: '/outOfOrderRequest',
        }).then((res) => {
          if (res.data.status) {
            outofStock = true;
            if (res.data.reason === 'MANUAL') {
              history.push(`/machineUI/out-of-order/${machineID}`);
            } else {
              history.push(`/machineUI/out-of-order/${machineID}`);
            }
          } else {
            outofStock = false;
          }
        });
      }

      if (props.test == 'false') {
        await localRequest({
          method: 'get',
          url: '/getInventory',
        }).then((res) => {
          if (res.data.items) {
            items = res.data.items;
            // if (res.data.items_error && res.data.items_error.length > 0) {
            //   errorItems = res.data.items_error;
            //   console.log(errorItems);
            // }
          }
        });
      }
    };

    async function getCates() {
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getAllCateURL,
        })
          .then((res) => {
            categoryArray = res.data;
            console.log('localCate', res.data);
            localStorage.setItem('category', JSON.stringify(res.data));
          })
          .catch((err) => {
            console.log(err);
            logger(0, 'Errors when downloading categorys' + JSON.stringify(err));
          });
      } else {
        await request({
          method: 'get',
          url: getAllCateURLR + machineID,
        })
          .then((res) => {
            categoryArray = res.data[0];
            localStorage.setItem('category', JSON.stringify(res.data[0]));
          })
          .catch((err) => {
            console.log(err);
            logger(0, 'Errors when downloading categorys' + JSON.stringify(err));
          });
      }
    }

    async function getBrands() {
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getAllBrandURL,
        })
          .then((res) => {
            console.log('localBrand', res.data);
            localStorage.setItem('brand', JSON.stringify(res.data));
          })
          .catch((err) => {
            console.log(err);
            logger(0, 'Errors when downloading brands' + JSON.stringify(err));
          });
      } else {
        await request({
          method: 'get',
          url: getAllBrandURLR + machineID,
        })
          .then((res) => {
            localStorage.setItem('brand', JSON.stringify(res.data[0]));
          })
          .catch((err) => {
            console.log(err);
            logger(0, 'Errors when downloading brands' + JSON.stringify(err));
          });
      }
    }

    async function getProds() {
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getAllProdURL,
        })
          .then(async (res) => {
            console.log('localProduct', res.data);
            voidProd(res);
          })
          .catch((err) => {
            console.log(err);
            logger(0, 'Errors when downloading products' + JSON.stringify(err));
          });
      } else {
        await request({
          method: 'get',
          url: getAllProdURLR + machineID,
        })
          .then(async (res) => {
            console.log('remoteProduct', res.data);
            voidProd(res);
          })
          .catch((err) => {
            console.log(err);
            logger(0, 'Errors when downloading products' + JSON.stringify(err));
          });
      }
    }

    if (props.test == 'true') {
      localStorage.setItem('testMode', 'true');
      props.setTestMode(true);
    } else {
      localStorage.setItem('testMode', 'false');
      await updateStatus();
      props.setTestMode(false);
    }

    let run = async function () {
      await getPromo();
      await getMachine();
      await getProds();
      await getCates();
      await getBrands();
      logger(2, 'Reset machine');
    };
    const nextPage = () => {
      stat.time = new Date();
      setStat(stat);
      //go to screensaver linked page directly instead of home page
      console.log('linkedpromo', props.linkPromo);
      console.log('filteredProducts', filteredProducts);
      console.log('cate', categoryArray);
      let found = false;
      if (props.linkPromo) {
        if (props.linkPromo?.id !== '') {
          if (props.linkPromo?.p === 'prod') {
            filteredProducts.forEach((e) => {
              if (e._id === props.linkPromo.id) {
                found = true;
                console.log('gogo');
                history.push(`/machineUI/product/${machineID}/${e._id}/${e.idx}`);
              }
            });
          }
          if (props.linkPromo?.p === 'cate') {
            categoryArray.forEach((e) => {
              if (e._id === props.linkPromo.id) {
                if (!e.name[language] || !e.name[language] === '') {
                  e.name[language] = e.name.en;
                }
                localStorage.setItem('currentCate', JSON.stringify(e));
                found = true;
                history.push(`/machineUI/category/cate/${e.name[language]}/${e._id}`);
              }
            });
          }
        }
        if (!found) {
          history.push(`/machineUI/homePage/${machineID}`);
        }
      }
    };
    if (!outofStock) {
      run().then((e) => {
        nextPage();
      });
    }

    return () => {};
  }, []);

  return (
    <div className="main-container d-flex justify-content-center align-items-center">
      <div className="init-div">{t(`Initializing...`)}</div>
    </div>
  );
}
export default Initial;
